import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';

export const checkIsSlideBg = (items) => {
    let isSlideBg = false;
    items?.forEach((item) => {
        if (item.id === ActionType.FILLCOLOR) {
            isSlideBg = item.isSlideBg;
        }
    });
    return isSlideBg;
};

/**
 * 将alpha通道值转换成对应的透明度百分比
 * @param {number} alpha 小数，alpha通道，单位不是emu
 */
export const alphaToOpacity = alpha => Math.round((1 - alpha) * 100);

/**
  * 将UI上的透明度百分比转换成图形、图片等可以接受的alpha通道，单位不是emu
  * @param {number} opacity UI上显示的透明度百分比
  */
export const opacityToAlpha = opacity => Number((1 - (opacity / 100)).toFixed(2));

/**
 * 判断单选或者多选同一类型元素是否为指定类型
 */
export const checkIsType = (selectedModel, type: string): boolean => {
    const multiModelArr = getSelectedModelTypeArr(selectedModel);
    if (multiModelArr.length === 1) {
        return multiModelArr[0] === type;
    }
    return false;
};

/**
 * 获取选中元素类型的数组，且不重复
 */
export const getSelectedModelTypeArr = (selectedModel) => {
    const selectedModels = getAllChildModels(selectedModel);
    const typeArray: string[] = [];
    selectedModels?.forEach((model) => {
        if (typeArray.indexOf(model?.type) === -1) {
            typeArray.push(model?.type);
        }
    });
    return typeArray;
};

export const validNumber = (value: number, max = 100, min = 0): number => {
    if (isNaN(value) || value < min) return min;
    if (value > max) return max;
    return value;
};
